<div class="ic-recent">
  <div class="ic-recent__circle" [ngClass]="color"></div>
  <span>{{ label }}</span>
</div>
